import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@app/App';
import { env } from '@config/env';
import '@shared/styles/tokens.css';
import '@shared/styles/reset.css';
import '@shared/styles/globals.css';

async function enableMocking(): Promise<void> {
  if (!env.VITE_ENABLE_MSW) return;
  // Dynamic import keeps MSW out of the production bundle when the flag is off.
  const { worker } = await import('@test/msw/browser');
  // NOTE: do NOT unregister the worker on boot. A freshly-registered service
  // worker does not control the current page until the next navigation, so
  // first-load requests would bypass to the network and fail ("Network
  // unavailable") until a hard refresh. Handler changes are picked up live by
  // the HMR hook in browser.ts (worker.resetHandlers), and worker.start()
  // re-fetches/updates mockServiceWorker.js when the script itself changes —
  // so no manual purge is needed.
  await worker.start({
    onUnhandledRequest: 'bypass',
    serviceWorker: { url: '/mockServiceWorker.js' },
    quiet: true,
  });
}

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Fatal: #root element not found in index.html');
}

void enableMocking().then(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
